        import {Component,Inject, Input} from 'ng-metadata/core';
        import {UsernamePasswordLoginService} from './usernamePasswordLogin.service';
        import {JwtUtilService} from './jwtUtil.service';
        var angular:angular.IAngularStatic =  require('angular');

        @Component({
            selector: 'prm-username-password-login',
            templateUrl: 'components/security/username-password-login.html'
        })

        export class UsernamePasswordLoginController {
            @Input() authenticationProfileName :string;
            private password: string;
            private username: string;



            constructor(private usernamePasswordLoginService: UsernamePasswordLoginService,
                        @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                        private jwtUtilService: JwtUtilService,
                        @Inject('I18nService') private i18nService,
                        @Inject('$state') private $state: ng.ui.IStateService,
                        @Inject('$http') private $http: ng.IHttpService
            ) {

            }


            login() {
                let oldJwt= this.jwtUtilService.getDecodedToken().user;
                this.usernamePasswordLoginService.login(this.username, this.password, this.authenticationProfileName).then(()=>{
                    this.$mdDialog.hide();
                    let decodedJwt= this.jwtUtilService.getDecodedToken();
                    if ((decodedJwt.language != "") && (decodedJwt.language != this.i18nService.getLanguage())){

                        this.i18nService.setLanguage(decodedJwt.language).then(()=> {
                            this.$state.go(this.$state.current, {}, {reload: true});
                        });
                    }
                     this.usernamePasswordLoginService.copyFavoritesRecordsThatWereSavedForGuest(oldJwt);


                },(response)=>{
                    this.$mdDialog.show(
                        this.$mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Login failed')
                            .textContent('Username/Password is invalid')
                            .ok('Close')
                    );
                });
            }



        }




// WEBPACK FOOTER //
// ./src/main/webapp/components/security/usernamePasswordLogin.directive.ts